import React from "react";
import Select from "@mui/material/Select";
import PhoneInput from "react-phone-input-2";

import Hide from "assets/images/svg/hide.svg";
import Search from "assets/images/svg/search_blue.svg";

const Input = React.forwardRef(({ type, label, id, name, Class, ...props }, ref) => {
  const [showPassword, setShowPassword] = React.useState(false);

  switch (type) {
    case "check":
      return (
        <label className="inputcheck" htmlFor={id}>
          <input type="checkbox" id={id} {...props} ref={ref} />
          <span>{label}</span>
        </label>
      );

    case "phone":
      return (
        <div className={`input-div ${props.readonly ? "readonly" : ""}`}>
          <label
            className={`lapel-input ${props.error ? "error" : ""}  ${props.readonly ? "readonly" : ""} ${
              props.dashed ? "dashed" : ""
            }`}
          >
            {label ? (
              <span>
                {label} {require ? <small className="star-require">*</small> : ""}
              </span>
            ) : null}
            <PhoneInput disabled={props.readonly} country="eg" {...props} />
          </label>
          {props.error && <span className="text-error">{props.error}</span>}
        </div>
      );

    case "radio":
      return (
        <label className="inputRadio" htmlFor={id}>
          <input type="radio" id={id} ref={ref} name={name} {...props} defaultChecked={props.isChecked} />
          <span>{label}</span>
        </label>
      );
    case "select":
      return (
        <div className={`select-div ${Class}`}>
          <label className={`lapel-input ${props.error ? "error" : ""} ${props.readonly ? "readonly" : ""} `}>
            <span>{label}</span>
            <Select
              id={id}
              disabled={props.readonly}
              inputProps={{ "aria-label": "Without label" }}
              inputRef={ref}
              {...props}
              className="inputSelect"
            >
              {props.children}
            </Select>
          </label>
        </div>
      );

    case "password":
      return (
        <div className="input-div">
          <label className={`lapel-input ${props.error ? "error" : ""} ${props.readonly ? "readonly" : ""}`} htmlFor={id}>
            <span>{label}</span>
            <input
              name={name}
              disabled={props.readonly}
              type={showPassword ? "text" : type || "text"}
              id={id}
              placeholder={props.placeholder}
              {...props}
              ref={ref}
            />
            <img src={Hide} alt="hide" onClick={() => setShowPassword(!showPassword)} />
          </label>
          <span className="text-error">{props.error}</span>
          <span className="text-warning">{props.warning}</span>
        </div>
      );

    case "domain":
      return (
        <div className="input-div">
          <label className={`lapel-input ${props.error ? "error" : ""} ${props.readonly ? "readonly" : ""}`} htmlFor={id}>
            <span>{label}</span>
            <input disabled={props.readonly} type={type || "text"} id={id} placeholder={props.placeholder} {...props} ref={ref} />
            <p>.dexef.org</p>
          </label>
          <span className="text-error">{props.error}</span>
        </div>
      );

    case "search":
      return (
        <label className="input-search" htmlFor={id}>
          <input type="text" placeholder="search" id={id} />
          <span>
            <img src={Search} alt="Search" />
          </span>
        </label>
      );

    default:
      return (
        <div className="input-div">
          <label className={`lapel-input ${props.error ? "error" : ""} ${props.readonly ? "readonly" : ""}`} htmlFor={id}>
            <span>{label}</span>
            <input
              name={name}
              disabled={props.readonly}
              type={type || "text"}
              id={id}
              placeholder={props.placeholder}
              {...props}
              ref={ref}
              min="0"
            />
          </label>

          <span className="text-error">{props.error}</span>
        </div>
      );
  }
});

export default Input;
